<template>
  <div class="main-page">
    <center-spinner :loading="loading" />

    <div class="auth-content2">
      <div>
        <img
          src="../../../assets/img/new_app_logo.png"
          alt=""
          class="logo"
        >
      </div>

      <h1 class="header-style">
        Sign In
      </h1>

      <p class="subheader-style">
        Enter your mobile number.
      </p>

      <v-form>
        <vue-phone-number-input
          v-model="phone"
          :default-country-code="'AU'"
          class="mb-4"
          @update="onPhoneUpdate"
        />

        <p class="login-passcode-title">
          Enter Passcode
        </p>

        <div class="otp-style">
          <v-otp-input
            v-model="passcode"
            type="password"
            length="4"
            inputmode="numeric"
            light
            filled
            color="#37474F"
          />
        </div>

        <v-btn
          class="mt-2 btn-style confirm-button"
          elevation="0"
          @click="confirmPassCode"
        >
          Confirm
        </v-btn>

        <v-btn
          light
          class="mt-3 btn-style cancel-button"
          elevation="0"
          @click="cancelSignIn"
        >
          Cancel
        </v-btn>
      </v-form>

      <p
        class="para-style mt-3"
        @click="toPasscodeResetPage"
      >
        Forgot Passcode?
      </p>

      <p
        class="para-style"
        @click="toRegisterPage"
      >
        Don't Have an Account ?
      </p>
    </div>
  </div>
</template>

<script>
import Constants from 'src/constants';
import spinner from '../../components/SpinnerCentre.vue';
import axios from '@/app-axios';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

export default {
  name: 'AnotherAccountPage',

  components: {
    VuePhoneNumberInput,
    'center-spinner': spinner,
  },

  data () {
    return {
      loading: false,
      phone: null,
      nationalNumber: null,
      passcode: '',
    };
  },

  methods: {
    onPhoneUpdate (data) {
      if (data && data.isValid) {
        this.nationalNumber = data.nationalNumber;
      } else {
        this.nationalNumber = null;
      }
    },
    async confirmPassCode () {
      if (!this.nationalNumber) {
        this.$store.dispatch(
          'alert/onAlert',
          {
            message: 'Invalid mobile number',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        return;
      }

      if (!this.passcode) {
        this.$store.dispatch(
          'alert/onAlert',
          {
            message: 'Enter passcode',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        return;
      }
      this.loading = true;
      try {
        await axios.get('sanctum/csrf-cookie');

        await this.$store.dispatch('login', {
          phone_number: this.nationalNumber,
          password: this.passcode,
        });

        this.$router.push({ name: 'HomePage' });
      } catch (e) {
        this.$store.dispatch(
          'alert/onAlert',
          {
            message: 'These credentials do not match our records.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
      }

      this.loading = false;
    },
    cancelSignIn () {
      this.$router.push({ name: 'GetStarted' });
    },
    toPasscodeResetPage () {
      this.$router.push({ name: 'ResetPasscode' });
    },
    toRegisterPage () {
      this.$router.push({ name: 'Register' });
    },
  },
};
</script>

<style scoped>
.confirm-button {
  font-size: 15px;
  border-radius: 30px;
  background-color: #000 !important;
}

.cancel-button {
  font-size: 15px;
  border-radius: 30px;
}

.logo {
  width: 50px;
  margin-bottom: 10px;
}

/* Ensure dropdown text visible */
::v-deep(.vue-phone-number-input .country-selector__list) {
  background-color: #ffffff !important;
}

::v-deep(.vue-phone-number-input .country-selector__list__item) {
  color: #000000 !important;
}
</style>
